import {smartLabelsImageEnabled} from './smartLabelsImageEnabled';
import {smartLabelsVideoEnabled} from './smartLabelsVideoEnabled';

export const smartLabelsEnabled = () =>
	smartLabelsImageEnabled() || smartLabelsVideoEnabled();
